import { Portal } from '@mui/material';
import React from 'react';
import './CustomTopNavigation.scss';
import topNavTitlePro from '../topNavTitlePro.json';
import ProBadge from '../SubscriptionComponents/ProBadge/ProBadge';

const InnerContainerStyle = {
  position: 'relative',
  height: '100%'
};

const CustomTopNavigation = props => {
  const {
    className,
    children,
    title,
    shouldShowProBadge,
    // Optional: turns the PRO badge into a button. Only the client page passes
    // these (its way into ClientV2); everywhere else the badge stays a plain
    // decorative label, so it must not be spread onto the <ul> below.
    proBadgeOnClick,
    proBadgeActionLabel,
    // Optional node shown beside the title (the client page's 試新版 pill).
    // Only when it is passed does the title get the extra wrapper it needs to
    // be positioned against, so every other page's title is left untouched.
    titleAction,
    ...rest
  } = props;
  const proBadge = !!shouldShowProBadge && <ProBadge onClick={proBadgeOnClick} actionLabel={proBadgeActionLabel} />;
  return (
    <ul className={`navigation${className ? ` ${className}` : ''}`} {...rest}>
      <div style={InnerContainerStyle}>
        {title && (
          <li className="title">
            <div>
              <span>
                {titleAction ? (
                  <span className="title-with-action">
                    {title}
                    {proBadge}
                    <span className="title-action">{titleAction}</span>
                  </span>
                ) : (
                  <>
                    {title}
                    {proBadge}
                  </>
                )}
              </span>
            </div>
          </li>
        )}
        {children}
      </div>
    </ul>
  );
};

export const CustomTopNavigationWithPortal = props => (
  <Portal container={document.body}>
    <CustomTopNavigation {...props} />
  </Portal>
);

export default CustomTopNavigation;
